import { render } from "./ContactStrip.vue?vue&type=template&id=15298370&scoped=true"
import script from "./ContactStrip.vue?vue&type=script&lang=js"
export * from "./ContactStrip.vue?vue&type=script&lang=js"

import "./ContactStrip.vue?vue&type=style&index=0&id=15298370&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15298370"]])

export default __exports__